import { useState } from "react";
import { useTranslation } from "react-i18next";

import TkProcessTempleteDialog from '../dialogTypes/TkProcessTempleteDialog';
import UpdateRecordButton from "./UpdateRecordButton";

function TkProcessTempleteUpdateButton ( props ) {

    const { t } = useTranslation();

    const { id, schema, grid, api, onSuccess, onSelect, ...others } = props;
    const [ open, setOpen ] = useState(false);
    const [formData, setFormData] = useState();

    const onOpen = () => {

        if (grid) {
            setFormData({ ...grid.selectedItems[0] });
        }

        setOpen ( true );

    };

    const onClose = () => {

        setOpen ( false );

    };

    const onUpdateSuccess = ( msg ) => {

        if ( onSuccess ) {

            onSuccess ( msg );
            
        }

        if(api) {

            api.refresh();
        }
    };

    return (

        <>
            <UpdateRecordButton id={id+"update-button"} onClick={onOpen} {...others} />
            <TkProcessTempleteDialog
                id={id+"update-dialog"}
                mode="edit"
                formId={id+"update-form"}
                onSelect = {onSelect}
                title={ schema ? t ( `dialog.title.${schema.name}.update` ) : "" }
                schema={schema}
                initialData = {formData}
                open={open}
                onClose={onClose}
                onSuccess={onUpdateSuccess}
            />
        </>

    );
}

export default TkProcessTempleteUpdateButton;

